import { render, staticRenderFns } from "./ListDescuentos.vue?vue&type=template&id=32815cf8&"
import script from "./ListDescuentos.vue?vue&type=script&lang=js&"
export * from "./ListDescuentos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports